import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col-lg-4 col-sm-6" }
const _hoisted_3 = { class: "left-header-content" }
const _hoisted_4 = { class: "d-flex align-items-center ps-0 mb-0 list-unstyled justify-content-center justify-content-sm-start" }
const _hoisted_5 = { class: "col-lg-8 col-sm-6" }
const _hoisted_6 = { class: "right-header-content mt-2 mt-sm-0" }
const _hoisted_7 = { class: "d-flex align-items-center justify-content-center justify-content-sm-end ps-0 mb-0 list-unstyled" }
const _hoisted_8 = { class: "header-right-item" }
const _hoisted_9 = { class: "header-right-item" }
const _hoisted_10 = { class: "header-right-item" }
const _hoisted_11 = { class: "header-right-item" }
const _hoisted_12 = { class: "header-right-item" }
const _hoisted_13 = { class: "header-right-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchFrom = _resolveComponent("SearchFrom")!
  const _component_WebApps = _resolveComponent("WebApps")!
  const _component_DarkSwtichBtn = _resolveComponent("DarkSwtichBtn")!
  const _component_LanguageMenu = _resolveComponent("LanguageMenu")!
  const _component_ToggleFullscreenBtn = _resolveComponent("ToggleFullscreenBtn")!
  const _component_NotificationsLists = _resolveComponent("NotificationsLists")!
  const _component_AdminProfile = _resolveComponent("AdminProfile")!
  const _component_SettingsBtn = _resolveComponent("SettingsBtn")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass([
      'header-area bg-white mb-4 rounded-bottom-15',
      { sticky: _ctx.isSticky },
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: _normalizeClass(["header-burger-menu bg-transparent p-0 border-0", [
                  'header-burger-menu bg-transparent p-0 border-0',
                  { active: _ctx.stateStoreInstance.open },
                ]]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
              }, _cache[1] || (_cache[1] = [
                _createElementVNode("span", { class: "material-symbols-outlined" }, "menu", -1)
              ]), 2)
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_SearchFrom)
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_WebApps)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_DarkSwtichBtn)
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_LanguageMenu)
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_ToggleFullscreenBtn)
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createVNode(_component_NotificationsLists)
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createVNode(_component_AdminProfile)
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createVNode(_component_SettingsBtn)
            ])
          ])
        ])
      ])
    ])
  ], 2))
}